// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "e5591e55d300f6a3cfae581f72a6f8da" + ".js";
};